import { LocalStorageStore } from './LocalStorageStore';

export const CurrentBusinessIdStore = new LocalStorageStore<string>(
  'CURRENT_BUSINESS_ID',
  (x) => x,
  (x) => x,
);
